import { compose } from 'recompose'
import { connect } from 'react-redux'
import withHandlePhoneLinkClick from 'components/common/hoc/withHandlePhoneLinkClick'
import withConfigureHandleShopTires from 'components/common/hoc/withConfigureHandleShopTires'
import NoResultComponent from './NoResultComponent'
import { formatPhoneNumber } from 'helpers/phone-number'
import { refresh } from 'actions/router'

const mapStateToProps = ({ myStore }) => ({
  myStore,
  storePhoneNumber: myStore ? myStore.phoneNumbers[0] : undefined,
  formattedStorePhoneNumber: myStore ? formatPhoneNumber(myStore.phoneNumbers[0]) : undefined
})

export default compose(
  connect(mapStateToProps, { refresh }),
  withHandlePhoneLinkClick,
  withConfigureHandleShopTires
)(NoResultComponent)
